import styled from 'styled-components'

const StyledSocialProfiles = styled.div`
  .new-profile-btn {
    margin-top: 20px;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s;
    border-radius: 6px;
    padding: 0 12px;
    font-weight: 600;
    user-select: none;
    border: 1px solid ${({ theme }) => theme.colors.gray[100]};
    background-color: ${({ theme }) => theme.colors.gray[100]};
    color: ${({ theme }) => theme.colors.gray[600]};

    span {
      position: relative;
      top: 1px;
    }

    svg {
      height: 18px;
      margin-right: 8px;
    }

    &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.colors.gray[200]};
    }
  }
`

export default StyledSocialProfiles
